// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".banner .btn[data-v-263d04cc]{width:auto;min-width:200px;padding-right:2rem;width:-moz-fit-content;width:fit-content}", ""]);
// Exports
module.exports = exports;
